import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

import { useTranslation } from 'react-i18next';

import NotFoundSmall from 'assets/images/notFoundSmall.png';

export const NoResultsRoot = styled('div')(({ theme }) => ({
  position: 'absolute',
  inset: 0,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
  height: '100%',
  gap: theme.spacing(10),
}));

type NoRowsOverlayProps = {
  message?: string;
};

export const NoRowsOverlay = ({ message }: NoRowsOverlayProps) => {
  const { t } = useTranslation();

  return (
    <NoResultsRoot>
      <img src={NotFoundSmall} alt="" />
      <Typography variant="h3" color="text.secondary">
        {message ?? t('common.noResults')}
      </Typography>
    </NoResultsRoot>
  );
};

export const DefaultNoRowsOverlay = () => <NoRowsOverlay />;
